export const enum EWebimKey {
  WEBIM_VISITOR = 'wvcuverse',
  WEBIM_VISIT_SESSION_ID = 'wskcuverse',
}
